import Vue from 'vue'
import Vuex from 'vuex'
import { createSubscription, upgradeSubscription, createCreditsPurchase } from '../api/stripe'
import { getCurrentUser } from '../api/auth'

Vue.use(Vuex)

var LAST_ERROR_MODAL = {
  signature: '',
  shownAt: 0
}
var PENDING_CONFIRM_CALLBACKS = {
  onConfirm: null,
  onCancel: null
}

export default new Vuex.Store({
  state: {
    locale: 'zh',
    sidebarOpen: true,
    currentModel: null,
    billingCycle: 'yearly',
    paymentLoading: false,
    paymentError: null,
    subscription: null,
    userInfo: null,
    upgradeSuccess: false,
    upgradeError: false,
    errorModal: {
      visible: false,
      title: '',
      message: '',
      detailMessage: ''
    },
    pendingGeneration: null,
    confirmModal: {
      visible: false,
      title: '',
      message: '',
      confirmText: '',
      cancelText: ''
    },
    showLoginModal: false,
    imageModels: [
      { id: 'seedream-5', name: 'Seedream 5', category: 'new', badge: 'New', descKey: 'models.image.seedream-5.desc', credits: 10, speed: '~15s' },
      { id: 'flux-2', name: 'FLUX.2', category: 'new', badge: 'New', descKey: 'models.image.flux-2.desc', credits: 7, speed: '~15s' },
      { id: 'qwen-image-2-0-pro', name: 'Qwen Image 2.0 Pro', category: 'new', badge: 'New', descKey: 'models.image.qwen-image-2-0-pro.desc', credits: 10, speed: '~20s' },
      { id: 'sd-3-5', name: 'Stable Diffusion 3.5', routeId: 'stable-diffusion-3-5', category: 'new', badge: 'New', descKey: 'models.image.sd-3-5.desc', credits: 10, speed: '~20s' },
      // { id: 'nano-banana-2', name: 'Nano Banana 2', category: 'new', badge: '', descKey: 'models.image.nano-banana.desc', credits: 5, speed: '~20s' }, // 暂时隐藏
      { id: 'z-image-turbo', name: 'Z Image Turbo', category: 'new', badge: '', descKey: 'models.image.z-image-turbo.desc', credits: 10, speed: '~20s' },
      { id: 'seedream-4', name: 'Seedream 4', category: 'other', badge: '', descKey: 'models.image.seedream-4.desc', credits: 10, speed: '~15s' },
      { id: 'midjourney', name: 'Midjourney', category: 'other', badge: 'Hot', descKey: 'models.image.midjourney.desc', credits: 10, speed: '~20s' },
      { id: 'gpt-image-1', name: 'GPT-Image-1', category: 'other', badge: '', descKey: 'models.image.gpt-image-1.desc', credits: 10, speed: '~15s' },
      { id: 'gpt-image-1-5', name: 'GPT-Image-1-5', category: 'other', badge: '', descKey: 'models.image.gpt-image-1-5.desc', credits: 10, speed: '~15s' },
      { id: 'flux-pro-1-1-ultra', name: 'Flux Pro 1.1 Ultra', category: 'other', badge: 'Hot', descKey: 'models.image.flux-pro-1-1-ultra.desc', credits: 7, speed: '~15s' },
      { id: 'flux-schnell', name: 'Flux Schnell', category: 'other', badge: '', descKey: 'models.image.flux-schnell.desc', credits: 2, speed: '~15s' }
    ],
    videoModels: [
      { id: 'wan-2-6', name: 'Wan 2.6', category: 'new', badge: 'New', descKey: 'models.video.wan-2-6.desc', credits: 75, speed: '~2min' },
      { id: 'kling-3', name: 'Kling 3', category: 'new', badge: 'New', descKey: 'models.video.kling-3.desc', credits: 28, speed: '~2min' },
      { id: 'veo-3-1', name: 'Veo 3.1', category: 'new', badge: 'Hot', descKey: 'models.video.veo-3-1.desc', credits: 30, speed: '~3min' },
      { id: 'pollodance', name: 'Pollo Dance', category: 'new', badge: 'New', descKey: 'models.video.pollodance.desc', credits: 30, speed: '~2min' },
      { id: 'seegen', name: 'SeeGen', category: 'new', badge: 'New', descKey: 'models.video.seegen.desc', credits: 20, speed: '~2min' },
      { id: 'seedance', name: 'Seedance 1.5 Pro', navName: 'Seedance AI', routeId: 'seedance-1-5', category: 'new', badge: '', descKey: 'models.video.seedance.desc', credits: 8, speed: '~1.5min' },
      { id: 'wan-2-5', name: 'Wan 2.5', category: 'new', badge: '', descKey: 'models.video.wan-2-5.desc', credits: 30, speed: '~2min' },
      { id: 'kling-2-6', name: 'Kling 2.6', category: 'new', badge: '', descKey: 'models.video.kling-2-6.desc', credits: 28, speed: '~2min' },
      { id: 'vidu-q3-pro', name: 'Vidu Q3 Pro', category: 'new', badge: '', descKey: 'models.video.vidu-q3-pro.desc', credits: 40, speed: '~2min' },
      { id: 'sora-2', name: 'Sora 2', category: 'other', badge: 'Hot', descKey: 'models.video.sora-2.desc', credits: 40, speed: '~3min' },
      { id: 'kling-2-5', name: 'Kling 2.5', category: 'other', badge: '', descKey: 'models.video.kling-2-5.desc', credits: 30, speed: '~2min' },
      { id: 'wan-2-2', name: 'Wan 2.2', category: 'other', badge: '', descKey: 'models.video.wan-2-2.desc', credits: 25, speed: '~2min' },
      { id: 'veo-3-0', name: 'Veo 3.0', category: 'other', badge: '', descKey: 'models.video.veo-3-0.desc', credits: 30, speed: '~2min' },
      { id: 'hailuo-2-3', name: 'Hailuo 2.3', category: 'other', badge: '', descKey: 'models.video.hailuo-2-3.desc', credits: 40, speed: '~2min' },
      { id: 'runway', name: 'Runway', category: 'other', badge: '', descKey: 'models.video.runway.desc', credits: 15, speed: '~3min' },
      { id: 'wan-animate', name: 'Wan Animate', category: 'other', badge: '', descKey: 'models.video.wan-animate.desc', credits: 20, speed: '~2min' }
    ],
    tools: [
      // 图片处理
      { id: 'watermark-remover', nameKey: 'tools.watermark-remover.name', icon: '💧', badge: 'Hot', descKey: 'tools.watermark-remover.desc', category: 'image' },
      { id: 'background-remover', nameKey: 'tools.background-remover.name', icon: '✂️', badge: '', descKey: 'tools.background-remover.desc', category: 'image' },
      { id: 'image-eraser', nameKey: "tools['image-eraser'].name", icon: '🩹', badge: 'New', descKey: "tools['image-eraser'].desc", category: 'image' },
      { id: 'background-blur', nameKey: "tools['background-blur'].name", icon: '🌫️', badge: 'New', descKey: "tools['background-blur'].desc", category: 'image' },
      { id: 'object-remover', nameKey: "tools['object-remover'].name", icon: '🧹', badge: 'New', descKey: "tools['object-remover'].desc", category: 'image' },
      { id: 'ai-person-remover', nameKey: "tools['ai-person-remover'].name", icon: '🚷', badge: 'New', descKey: "tools['ai-person-remover'].desc", category: 'image' },
      { id: 'handwritten-erase', nameKey: 'tools.handwritten-erase.name', icon: '✏️', badge: '', descKey: 'tools.handwritten-erase.desc', category: 'image' },
      { id: 'doc-crop-enhance', nameKey: 'tools.doc-crop-enhance.name', icon: '📄', badge: '', descKey: 'tools.doc-crop-enhance.desc', category: 'image' },
      { id: 'ai-change-clothes', nameKey: 'tools.ai-change-clothes.name', icon: '👕', badge: '', descKey: 'tools.ai-change-clothes.desc', category: 'image' },
      { id: 'photo-restore', nameKey: 'tools.photo-restore.name', icon: '🖼️', badge: '', descKey: 'tools.photo-restore.desc', category: 'image' },
      { id: 'white-background', nameKey: 'tools.white-background.name', icon: '⬜', badge: 'New', descKey: 'tools.white-background.desc', category: 'image' },
      { id: 'blue-background', nameKey: 'tools.blue-background.name', icon: '🟦', badge: 'New', descKey: 'tools.blue-background.desc', category: 'image' },
      { id: 'face-swap', nameKey: 'tools.face-swap.name', icon: '🎭', badge: 'New', descKey: 'tools.face-swap.desc', category: 'image' },
      { id: 'blurry-photo-repair', nameKey: 'tools.blurry-photo-repair.name', icon: '🔍', badge: '', descKey: 'tools.blurry-photo-repair.desc', category: 'image' },
      { id: 'cartoon-digital-human', nameKey: 'tools.cartoon-digital-human.name', icon: '🎨', badge: '', descKey: 'tools.cartoon-digital-human.desc', category: 'image' },
      { id: 'manga-digital-human', nameKey: 'tools.manga-digital-human.name', icon: '📚', badge: '', descKey: 'tools.manga-digital-human.desc', category: 'image' },
      { id: 'oil-painting-digital-human', nameKey: 'tools.oil-painting-digital-human.name', icon: '🎨', badge: '', descKey: 'tools.oil-painting-digital-human.desc', category: 'image' },
      { id: 'id-photo-generator', nameKey: 'tools.id-photo-generator.name', icon: '🪪', badge: '', descKey: 'tools.id-photo-generator.desc', category: 'image' },
      { id: 'ai-text-remover', nameKey: 'tools.ai-text-remover.name', icon: '🔤', badge: '', descKey: 'tools.ai-text-remover.desc', category: 'image' },
      { id: 'ai-logo-remover', nameKey: 'tools.ai-logo-remover.name', icon: '🏷️', badge: '', descKey: 'tools.ai-logo-remover.desc', category: 'image' },
      { id: 'ai-passersby-remover', nameKey: 'tools.ai-passersby-remover.name', icon: '🚶', badge: '', descKey: 'tools.ai-passersby-remover.desc', category: 'image' },
      // 视频处理
      { id: 'cartoon-video-style-converter', nameKey: 'tools.cartoon-video-style-converter.name', icon: '🎬', badge: 'New', descKey: 'tools.cartoon-video-style-converter.desc', category: 'video' },
      { id: 'anime-video-style-converter', nameKey: 'tools.anime-video-style-converter.name', icon: '🎞️', badge: 'New', descKey: 'tools.anime-video-style-converter.desc', category: 'video' },
      { id: 'oil-painting-video-style-converter', nameKey: 'tools.oil-painting-video-style-converter.name', icon: '🖌️', badge: 'New', descKey: 'tools.oil-painting-video-style-converter.desc', category: 'video' },
      { id: 'cyberpunk-video-style-converter', nameKey: 'tools.cyberpunk-video-style-converter.name', icon: '🌃', badge: 'New', descKey: 'tools.cyberpunk-video-style-converter.desc', category: 'video' },
      // 文档处理
      { id: 'pdf-to-word', nameKey: 'tools.pdf-to-word.name', icon: '📝', badge: 'New', descKey: 'tools.pdf-to-word.desc', category: 'document' },
      { id: 'image-to-word', nameKey: 'tools.image-to-word.name', icon: '🖼️', badge: '', descKey: 'tools.image-to-word.desc', category: 'document' },
      // { id: 'pdf-to-excel', nameKey: 'tools.pdf-to-excel.name', icon: '📊', badge: 'New', descKey: 'tools.pdf-to-excel.desc', category: 'document' },
      // { id: 'pdf-to-ppt', nameKey: 'tools.pdf-to-ppt.name', icon: '📽️', badge: '', descKey: 'tools.pdf-to-ppt.desc', category: 'document' },
      { id: 'pdf-to-image', nameKey: 'tools.pdf-to-image.name', icon: '🖼️', badge: '', descKey: 'tools.pdf-to-image.desc', category: 'document' },
      { id: 'word-to-pdf', nameKey: 'tools.word-to-pdf.name', icon: '📄', badge: '', descKey: 'tools.word-to-pdf.desc', category: 'document' },
      { id: 'excel-to-pdf', nameKey: 'tools.excel-to-pdf.name', icon: '📈', badge: '', descKey: 'tools.excel-to-pdf.desc', category: 'document' },
      { id: 'image-to-pdf', nameKey: 'tools.image-to-pdf.name', icon: '🔗', badge: '', descKey: 'tools.image-to-pdf.desc', category: 'document' },
      { id: 'word-to-image', nameKey: 'tools.word-to-image.name', icon: '📃', badge: '', descKey: 'tools.word-to-image.desc', category: 'document' }
    ],
    toolCategories: [
      { id: 'image', nameKey: 'tools.category.image', icon: '🎨' },
      { id: 'video', nameKey: 'tools.category.video', icon: '🎬' },
      { id: 'document', nameKey: 'tools.category.document', icon: '📄' }
    ],
    plans: [
      {
        id: 'basic',
        planName: 'basic',
        nameKey: 'plans.basic.name',
        monthlyPrice: 9.9,
        yearlyPrice: 7.9,
        yearlyTotal: 94.8,
        monthlySaving: 24,
        credits: 4800,
        bonusCredits: 400,
        creditsPer100: 1.82,
        featuresKeys: ['plans.basic.features.0', 'plans.basic.features.1', 'plans.basic.features.2', 'plans.basic.features.3', 'plans.basic.features.4', 'plans.basic.features.5'],
        popular: false,
        stripePriceIdMonthly: 'price_1TA5KHCLTzLOzB85YQN1xd1B',
        stripePriceIdYearly: 'price_1TA8TBCLTzLOzB85D2fp0fXC'
      },
      {
        id: 'pro',
        planName: 'professional',
        nameKey: 'plans.pro.name',
        monthlyPrice: 29.9,
        yearlyPrice: 19.9,
        yearlyTotal: 238.8,
        monthlySaving: 120,
        credits: 19200,
        bonusCredits: 2000,
        creditsPer100: 1.13,
        featuresKeys: ['plans.pro.features.0', 'plans.pro.features.1', 'plans.pro.features.2', 'plans.pro.features.3', 'plans.pro.features.4', 'plans.pro.features.5', 'plans.pro.features.6', 'plans.pro.features.7'],
        popular: true,
        stripePriceIdMonthly: 'price_1TBUGJCLTzLOzB85DkU3VYk0',
        stripePriceIdYearly: 'price_1TBUHKCLTzLOzB85xTebj6Ki'
      },
      {
        id: 'ultimate',
        planName: 'ultra',
        nameKey: 'plans.ultimate.name',
        monthlyPrice: 99,
        yearlyPrice: 69,
        yearlyTotal: 828,
        monthlySaving: 360,
        credits: 67200,
        bonusCredits: 6000,
        creditsPer100: 1.12,
        featuresKeys: ['plans.ultimate.features.0', 'plans.ultimate.features.1', 'plans.ultimate.features.2', 'plans.ultimate.features.3', 'plans.ultimate.features.4', 'plans.ultimate.features.5', 'plans.ultimate.features.6'],
        popular: false,
        stripePriceIdMonthly: 'price_1TBUOFCLTzLOzB85ALqPsOeL',
        stripePriceIdYearly: 'price_1TBUQQCLTzLOzB85dWI15yAk'
      }
    ],
    creditOptions: [
      { credits: 1200, price: 30, rate: '2.50', stripePriceId: 'price_1TBUTXCLTzLOzB85vabnAKxd' },
      { credits: 3000, price: 70, rate: '2.33', stripePriceId: 'price_1TBUTqCLTzLOzB85NFlaAI93' },
      { credits: 6000, price: 130, rate: '2.17', stripePriceId: 'price_1TBUU6CLTzLOzB85TbdgKbJa' },
      { credits: 12000, price: 240, rate: '2.00', stripePriceId: 'price_1TBUUOCLTzLOzB85gSdQs0L4' }
    ],
    planLevels: {
      'basic_monthly': 1,
      'professional_monthly': 2,
      'ultra_monthly': 3,
      'basic_yearly': 4,
      'professional_yearly': 5,
      'ultra_yearly': 6
    },
    faqKeys: [
      { qKey: 'faq.items.0.q', aKey: 'faq.items.0.a', category: 'general' },
      { qKey: 'faq.items.1.q', aKey: 'faq.items.1.a', category: 'models' },
      { qKey: 'faq.items.2.q', aKey: 'faq.items.2.a', category: 'pricing' },
      { qKey: 'faq.items.3.q', aKey: 'faq.items.3.a', category: 'features' },
      { qKey: 'faq.items.4.q', aKey: 'faq.items.4.a', category: 'features' },
      { qKey: 'faq.items.5.q', aKey: 'faq.items.5.a', category: 'general' },
      { qKey: 'faq.items.6.q', aKey: 'faq.items.6.a', category: 'features' },
      { qKey: 'faq.items.7.q', aKey: 'faq.items.7.a', category: 'features' },
      { qKey: 'faq.items.8.q', aKey: 'faq.items.8.a', category: 'general' },
      { qKey: 'faq.items.9.q', aKey: 'faq.items.9.a', category: 'general' },
      { qKey: 'faq.items.10.q', aKey: 'faq.items.10.a', category: 'general' },
      { qKey: 'faq.items.11.q', aKey: 'faq.items.11.a', category: 'general' }
    ],
    testimonialKeys: [
      { name: 'Alex Chen', roleKey: 'testimonials.items.0.role', initials: 'AC', tagKey: 'testimonials.items.0.tag', contentKey: 'testimonials.items.0.content' },
      { name: 'Sarah Rodriguez', roleKey: 'testimonials.items.1.role', initials: 'SR', tagKey: 'testimonials.items.1.tag', contentKey: 'testimonials.items.1.content' },
      { name: 'David Kim', roleKey: 'testimonials.items.2.role', initials: 'DK', tagKey: 'testimonials.items.2.tag', contentKey: 'testimonials.items.2.content' },
      { name: 'Emma Thompson', roleKey: 'testimonials.items.3.role', initials: 'ET', tagKey: 'testimonials.items.3.tag', contentKey: 'testimonials.items.3.content' },
      { name: 'James Wilson', roleKey: 'testimonials.items.4.role', initials: 'JW', tagKey: 'testimonials.items.4.tag', contentKey: 'testimonials.items.4.content' },
      { name: 'Lisa Park', roleKey: 'testimonials.items.5.role', initials: 'LP', tagKey: 'testimonials.items.5.tag', contentKey: 'testimonials.items.5.content' }
    ]
  },
  mutations: {
    SET_LOCALE(state, locale) { state.locale = locale },
    SET_SIDEBAR(state, open) { state.sidebarOpen = open },
    TOGGLE_SIDEBAR(state) { state.sidebarOpen = !state.sidebarOpen },
    SET_CURRENT_MODEL(state, model) { state.currentModel = model },
    SET_BILLING_CYCLE(state, cycle) { state.billingCycle = cycle },
    SET_PAYMENT_LOADING(state, loading) { state.paymentLoading = loading },
    SET_PAYMENT_ERROR(state, error) { state.paymentError = error },
    SET_SUBSCRIPTION(state, subscription) { state.subscription = subscription },
    SET_USER_INFO(state, userInfo) { state.userInfo = userInfo },
    SET_UPGRADE_SUCCESS(state, success) { state.upgradeSuccess = success },
    SET_UPGRADE_ERROR(state, error) { state.upgradeError = error },
    SET_ERROR_MODAL(state, payload) {
      state.errorModal = {
        visible: payload.visible,
        title: payload.title || '',
        message: payload.message || '',
        detailMessage: payload.detailMessage || ''
      }
    },
    SET_CONFIRM_MODAL(state, payload) {
      state.confirmModal = {
        visible: payload.visible,
        title: payload.title || '',
        message: payload.message || '',
        confirmText: payload.confirmText || '',
        cancelText: payload.cancelText || ''
      }
    },
    SET_SHOW_LOGIN_MODAL(state, show) {
      state.showLoginModal = show
    },
    SET_PENDING_GENERATION(state, pending) {
      state.pendingGeneration = pending
    }
  },
  actions: {
    setLocale({ commit }, locale) { commit('SET_LOCALE', locale) },
    toggleSidebar({ commit }) { commit('TOGGLE_SIDEBAR') },
    setBillingCycle({ commit }, cycle) { commit('SET_BILLING_CYCLE', cycle) },

    subscribeToPlan({ commit, state }, payload) {
      var plan = payload.plan
      var isUpgrade = payload.isUpgrade || false
      commit('SET_PAYMENT_LOADING', true)
      commit('SET_PAYMENT_ERROR', null)
      
      var price = state.billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice
      var stripePriceId = state.billingCycle === 'yearly' ? plan.stripePriceIdYearly : plan.stripePriceIdMonthly
      
      var planData = {
        stripePriceId: stripePriceId,
        price: price,
        credits: plan.credits,
        bonusCredits: plan.bonusCredits
      }
      
      if (isUpgrade) {
        upgradeSubscription(plan.planName, state.billingCycle, planData).then(function(res) {
          if (res && res.code === 200) {
            return getCurrentUser().then(function(userRes) {
              if (userRes && userRes.success) {
                commit('SET_USER_INFO', userRes.user)
                commit('SET_PAYMENT_LOADING', false)
                commit('SET_UPGRADE_SUCCESS', true)
              }
            })
          } else if (res && res.code === 502) {
            commit('SET_PAYMENT_LOADING', false)
          } else {
            commit('SET_PAYMENT_LOADING', false)
            commit('SET_UPGRADE_ERROR', true)
          }
        }).catch(function(err) {
          commit('SET_PAYMENT_LOADING', false)
          commit('SET_UPGRADE_ERROR', true)
        })
      } else {
        createSubscription(plan.planName, state.billingCycle, planData, false)
      }
    },

    purchaseCredits({ commit, state }, creditsOption) {
      commit('SET_PAYMENT_LOADING', true)
      commit('SET_PAYMENT_ERROR', null)
      
      var option = state.creditOptions.find(function(o) { return o.credits === creditsOption.credits }) || creditsOption
      createCreditsPurchase(option)
    },

    setPaymentLoading({ commit }, loading) {
      commit('SET_PAYMENT_LOADING', loading)
    },

    setPaymentError({ commit }, error) {
      commit('SET_PAYMENT_ERROR', error)
    },

    clearPaymentError({ commit }) {
      commit('SET_PAYMENT_ERROR', null)
    },

    showErrorModal({ commit }, payload) {
      var message = payload && payload.message ? String(payload.message) : ''
      var detailMessage = payload && payload.detailMessage ? String(payload.detailMessage) : ''
      var signature = message + '::' + detailMessage
      var now = Date.now()
      if (
        signature &&
        LAST_ERROR_MODAL.signature === signature &&
        now - LAST_ERROR_MODAL.shownAt < 1200
      ) {
        return
      }
      LAST_ERROR_MODAL.signature = signature
      LAST_ERROR_MODAL.shownAt = now
      commit('SET_ERROR_MODAL', {
        visible: true,
        title: payload.title || '',
        message: message,
        detailMessage: detailMessage
      })
    },

    hideErrorModal({ commit }) {
      commit('SET_ERROR_MODAL', {
        visible: false,
        title: '',
        message: '',
        detailMessage: ''
      })
    },

    showConfirmModal({ commit }, payload) {
      PENDING_CONFIRM_CALLBACKS.onConfirm = payload && typeof payload.onConfirm === 'function' ? payload.onConfirm : null
      PENDING_CONFIRM_CALLBACKS.onCancel = payload && typeof payload.onCancel === 'function' ? payload.onCancel : null
      commit('SET_CONFIRM_MODAL', {
        visible: true,
        title: payload && payload.title ? payload.title : '',
        message: payload && payload.message ? payload.message : '',
        confirmText: payload && payload.confirmText ? payload.confirmText : '',
        cancelText: payload && payload.cancelText ? payload.cancelText : ''
      })
    },

    confirmModalConfirm({ commit }) {
      var onConfirm = PENDING_CONFIRM_CALLBACKS.onConfirm
      PENDING_CONFIRM_CALLBACKS.onConfirm = null
      PENDING_CONFIRM_CALLBACKS.onCancel = null
      commit('SET_CONFIRM_MODAL', {
        visible: false,
        title: '',
        message: '',
        confirmText: '',
        cancelText: ''
      })
      if (onConfirm) onConfirm()
    },

    confirmModalCancel({ commit }) {
      var onCancel = PENDING_CONFIRM_CALLBACKS.onCancel
      PENDING_CONFIRM_CALLBACKS.onConfirm = null
      PENDING_CONFIRM_CALLBACKS.onCancel = null
      commit('SET_CONFIRM_MODAL', {
        visible: false,
        title: '',
        message: '',
        confirmText: '',
        cancelText: ''
      })
      if (onCancel) onCancel()
    },

    showLoginModal({ commit }) {
      commit('SET_SHOW_LOGIN_MODAL', true)
    },

    hideLoginModal({ commit }) {
      commit('SET_SHOW_LOGIN_MODAL', false)
    },

    clearUpgradeSuccess({ commit }) {
      commit('SET_UPGRADE_SUCCESS', false)
    },

    clearUpgradeError({ commit }) {
      commit('SET_UPGRADE_ERROR', false)
    }
  },
  getters: {
    allModels: state => [...state.imageModels, ...state.videoModels],
    newVideoModels: state => state.videoModels.filter(m => m.category === 'new'),
    otherVideoModels: state => state.videoModels.filter(m => m.category === 'other'),
    getModelById: state => id => {
      return [...state.imageModels, ...state.videoModels].find(m => m.id === id)
    },
    getToolById: state => id => {
      return state.tools.find(t => t.id === id)
    }
  }
})
